import ProtectedRoute from "@/shared/components/guards/ProtectedRoute";
import PlanLayout from "../layouts/PlanLayout";
import Membership from "../pages/Membership";
import MembershipConfirm from "../pages/MembershipConfirm";
import MembershipGate from "../components/MembershipGate";

const planRoutes = {
  path: "plan",
  element: (
    <ProtectedRoute>
      <PlanLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: "membership",
      element: (
        <MembershipGate>
          <Membership />
        </MembershipGate>
      ),
    },
    {
      path: "membership-confirm",
      element: <MembershipConfirm />,
    },
  ],
};

export default planRoutes;
